export const isRole = (roles, user) => {
  if(!user) return false;
  if(Array.isArray(roles)) {
    return roles.includes(user.roles[0].role.name)
  }
  return roles === user.roles[0].role.name; 
}